<template>
    <div>

        <Button type="dashed" title="添加图标" @click="openIconLibrary">
            <Icon type="ios-create-outline" size='18'/>
        </Button>

        <Modal v-model="modalDisPlay"
               width="700"  draggable sticky scrollable>
            <p slot="header" style="text-align:left">
                <i class="iconfont icon-ios-create" style="font-weight:700;"></i>
                <span> 选择图标</span>
            </p>
            <div id="search">
                <Input id="search-input" v-model="searchInput" style="display:inline-block;" type="text" placeholder="请输入"></Input>
                <br />
                <p id="search-p" style="display:inline-block;">输入Icon类名搜索，比如 success</p>
            </div>
            <div id="icon-box">
                <ul>
                    <li :id="item.id" class="icon-item" v-for="item in iconData" @click="selectedIcon(item)">
                        <svg class="icon" style="font-size: 20px;">
                            <use :xlink:href="item.iconClass" style="font-size: 30px;"></use>
                        </svg>
                        <!--<i :class="item.iconClass" style="font-weight:800;font-size:20px"></i>-->
                        <br />
                        <span>{{item.iconName}}</span>
                    </li>
                </ul>
            </div>
            <div id="page-box">
                <Page :total="iconCount" :page-size="pageSize"
                      @on-change="pageChange" show-total
                      :current="pageIndex"
                      style="display:inline-block;">
                </Page>
            </div>
            <div slot="footer">
            </div>
        </Modal>
    </div>
</template>

<script>
    import request from '@/utils/request'

    export default {
        name: 'LconLibrary',
        props: ['setIcon'],
        data() {
            return {
                searchInput: '',
                iconData: [],
                iconCount: 0,
                pageIndex:1,
                pageSize: 15,
                modalDisPlay: false
            }
        },

        methods: {
            initIconData(pageIndex) {
                var data = {
                    'IconName': this.searchInput,
                    'PageSize': this.pageSize,
                    'PageIndex': pageIndex
                }
                let component = this;
                request.post('/api/IconLibrary/GetIconLibraryList', data).then(function (response) {
                    component.iconData = response.data.iconLibraryVM;
                    component.iconCount = response.data.itemCount;

                }).catch(function (error) {
                })
                this.pageIndex = pageIndex;
            },
            openIconLibrary() {
                this.modalDisPlay = true;
                this.initIconData(1);
            },
            pageChange(index) {
                this.initIconData(index);
            },
            selectedIcon(icon) {
                this.setIcon(icon.iconClass);
                this.modalDisPlay = false;
            }
        },
        watch: {
            searchInput: function () {
                this.initIconData(1);
            }
        },
        created: function () {
        }
    }
</script>

<style scoped>
    #search {
        text-align: center;
        margin: 20px;
    }

    #search-input {
        width: 40%;
    }

    #search-p {
        margin-top: 20px;
    }

    #icon-box {
        margin: 20px 30px;
        overflow: hidden;
    }

    .icon-item {
        width: 100px;
        border: 1px solid #808080;
        height: 100px;
        text-align: center;
        border-radius: 3px;
        overflow: hidden;
        padding-top: 20px;
        padding-bottom: 20px;
        cursor: pointer;
        float: left;
        margin: 10px;
        position: relative;
    }

        .icon-item:hover {
            transform: scale(1.1);
        }
        .icon-item:focus {
            box-shadow: 0px 0px 1px 1px #808080;
        }

    #page-box{
        text-align:center;
    }
</style>
